import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import axios, { isAxiosError } from "axios"
import Loadingwrapper from "../../component/LoadingWrapper"
import { useSelector } from "react-redux"
import Pagination from "../../component/Pagination"

const HotpairFeed = ({ }) => {
  const [searchParams, setSearchParams] = useSearchParams({ gender: "F", type: "", page: 1, limit: 20 })
  const [loading, setLoading] = useState(true)
  const [count, setCount] = useState(0)
  const [trends, setTrends] = useState([])
  const userLoggedIn = useSelector(state => state.userLoggedIn)


  async function getTrends(signal) {

    try {
      const response = await axios.get(`/api/hot-pairs`, { params: searchParams, signal })
      if (response.data && response.data.trends) {
        setTrends(response.data.trends)
        setCount(response.data.count)
        setLoading(false)

      }
    } catch (e) {
      if (!isAxiosError(e)) {
        console.error(e)
      }
    }

  }

  useEffect(() => {
    setLoading(true)
    const aborter = new AbortController()
    getTrends(aborter.signal)
    return () => { aborter.abort() }


  }, [searchParams])
  function handlePageChange(value) {
    setSearchParams(prev => {
      prev.set('page', value)
      return prev
    })
  }

  return <div>
    <h2 className="text-center font-semibold text-2xl lg:text-[32px] p-0.5 lg:p-2">Hot Pairs</h2>
    <div className="sticky top-11 lg:top-10 z-10 bg-white" >
      <div className="w-screen flex justify-between flex-wrap">

        <div className="w-screen shrink-0 lg:shrink-1   flex lg:p-2 lg:px-2 flex-wrap justify-center lg:justify-start">
          <select className="p-1 rounded border mx-2"
            onChange={e => {
              setSearchParams(prev => {
                prev.set('gender', e.target.value)
                return prev
              })
            }}
            value={searchParams.get('gender') || 'F'}
          >
            <option disabled value={'select'}>--select gender--</option>
            <option value={'F'}>Women</option>
            <option value={'M'}>Men</option>
          </select>
          <select className="p-1 rounded border mx-2"
            onChange={e => {
              setSearchParams(prev => {
                prev.set('type', e.target.value)
                return prev
              })
            }}
            value={searchParams.get('type') || 'all'}
          >
            <option disabled value={'select'}>--select type--</option>
            <option value={'all'}>All hot pairs</option>
            <option value={'silhouette'}>Best Topwear and Bottomwear Silhouette combinations</option>
            <option value={'color'}>Best Color combination</option>
            <option value={'dress_color'}>Best Dress and Accessories Color combination</option>
          </select>
        </div>
      </div>

      <div className="justify-end flex w-screen">
        <Pagination
          count={Math.ceil(count / parseInt(searchParams.get('limit') || 20))}
          page={parseInt(searchParams.get('page') || 1)}
          onChange={handlePageChange}
        />
      </div>

    </div>


    <Loadingwrapper loading={loading} className="mb-4 lg:mb-40" >
      {trends.map((trend, index) => <div className="relative w-screen py-1">
        <div className="w-full pl-4 font-semibold text-lg">{((parseInt(searchParams.get('page') || '1') - 1) * (searchParams.get('limit') || '20')) + index + 1}. {trend.set1Value} {trend.set1Category} &times; {trend.set2Value} {trend.set2Category} - {trend.count}</div>
        <div className="flex w-full overflow-x-auto">
          {trend.images.map(im => <div className="h-60 px-1 w-auto shrink-0"><img src={im.imageUrl} className='h-full' /></div>)}
        </div>
      </div>)}

    </Loadingwrapper>




  </div>
}

export default HotpairFeed
